import React, { useCallback, useState } from "react";
import { CustomLinkSign } from "../../style/Login";
import {
  Container,
  Block,
  Block1,
  Icon,
  BlockText,
  Setting,
  Upload,
  Ad,
} from "../../style/Home";

import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { BiUpload } from "react-icons/bi";
import { RiHeartPulseLine } from "react-icons/ri";
import { FiSettings } from "react-icons/fi";
import { Logo1 } from "../logo/Logo";
import EhrLogin from "../EhrLogin/EhrLogin";
import HorizontalOne from "../../assets/Ads/Horizontal.jpeg";
import Heart from "../../assets/ehrlogin/newh.png";
import { verifyAuth } from "../../authverify";
import { isAdmin } from "../../authverify";
import axios from "axios";
import { render } from "@testing-library/react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import { Toast } from "primereact/toast";
import { FileUpload } from "primereact/fileupload";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.css";
import { serverUrl } from "../../appconst";
import "./primeUpload.css";
import { Border } from "devextreme-react/bar-gauge";

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import CustomizePopup from "./CustomizePopup"

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  icon: {
    cursor: "pointer",
  },
}));

class OgilyHome extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      selectedFile: null,
      imageurl: "",
      token: JSON.parse(window.sessionStorage.getItem("usersession")),
      open:false,
    };
    if (!verifyAuth()) {
      this.props.history.push({
        pathname: "/",
      });
    }

    this.setSelectedFile = this.setSelectedFile.bind(this);
    this.onClickHandler = this.onClickHandler.bind(this);
    this.updatePath = this.updatePath.bind(this);

    if (this.state.token) this.state.imageurl = this.state.token.logoloc;
  }

  setSelectedFile = (e) => {
    this.state.selectedFile = e.files[0];
  };

  updatePath = () => {
    fetch(serverUrl + "/api/user/updatepath", {
      method: "POST",
      headers: {
        "x-access-token": this.state.token.accessToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ path: this.state.imageurl }),
    })
      .then((response) => response.json())
      .then((result) => {
        console.log("Success:", result);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  onClickHandler = () => {
    const headers = {
      "x-access-token": this.state.token.accessToken,
    };
    if (this.state.selectedFile) {
      // let token = JSON.parse(window.sessionStorage.getItem("usersession"))
      const dataf = new FormData();
      dataf.append("userId", this.state.token.id);
      dataf.append("file", this.state.selectedFile);

      axios({
        method: "post",
        url: serverUrl + "/api/user/logoUpload",
        data: dataf,

        headers: {
          "Content-Type": "multipart/form-data",
          authorization: this.state.token.accessToken,
          "x-access-token": this.state.token.accessToken,
        },
      })
        .then((res) => {
          // then print response status
          //var data = JSON.parse(window.sessionStorage.getItem("usersession"));
          this.state.token.logoloc = res.data.location;
          window.sessionStorage.setItem(
            "usersession",
            JSON.stringify(this.state.token)
          );
          this.state.imageurl = res.data.location;
          this.updatePath();
          this.forceUpdate();
          this.toast.show({
            severity: "info",
            summary: "Success",
            detail: "File Uploaded",
          });
        })
        .catch((error) => {});
    }
  };

  createImage = () => {
    const chooseOptions = {
      icon: "pi-cog",
      className: ` p-button-rounded  p-button-icon-only  p-button-text  p-button-secondary p-0`,
    };
    if (this.state.imageurl) {
      return (
        <Upload>
          <img src={this.state.imageurl} style={{ width: "90px" }} alt="logo" />
          <form style={{ margin: "-7px" }}>
            <FileUpload
              chooseLabel=" "
              style={{ marginLeft: "65px", size: "30px" }}
              chooseOptions={chooseOptions}
              mode="basic"
              name="file"
              onSelect={this.setSelectedFile}
              url="https://primefaces.org/primereact/showcase/upload.php"
              accept="image/*"
              maxFileSize={1000000}
              onUpload={this.onClickHandler}
            />
          </form>
        </Upload>
      );
    } else {
      return (
        <Upload>
          <BiUpload size="22px" color="#3A8BD8" />
          <form className="noPI">
            <FileUpload
              mode="basic"
              name="file"
              onSelect={this.setSelectedFile}
              chooseLabel="Upload logo"
              url="https://primefaces.org/primereact/showcase/upload.php"
              accept="image/*"
              maxFileSize={1000000}
              onUpload={this.onClickHandler}
            />
            <div
              style={{
                color: "black",
                fontSize: "12px",
                marginTop: "-25px",
                marginLeft: "10px",
                fontWeight: 500,
              }}
            >
              Upload logo
            </div>
          </form>
        </Upload>
      );
    }
  };

  createSignUpLink = () => {
    if (this.state.token.role === "Admin") {
      return (
        <div>
          <CustomLinkSign to="/createuser"> Admin Section </CustomLinkSign>
        </div>
      );
    } else {
      return "";
    }
  };

  
  handleOpenPopup = () => {
    this.setState({ open: true });
  };

  handleClosePopup = () => {
    console.log("testing")
    this.setState({ open: false });
  };
  render() {
    const fragment = this.createImage();
    const signUpLink = this.createSignUpLink();
    return (
      <div>
        <div>
          <Logo1 />
        </div>

        <React.Fragment>{fragment}</React.Fragment>
        {signUpLink}
        {/* <Setting>
      <div style={{ fontSize: "30px", color: "orangered" }}>Ogily</div>
      
      </Setting> */}
        <Container>
          <Block>
            <EhrLogin />
            <BlockText
              color="#B263DE"
              top="215px"
              left="50px"
              style={{ fontSize: "15.5px" }}
            >
              Point of Care
            </BlockText>
            <BlockText
              color="grey"
              top="235px"
              left="80px"
              style={{ fontSize: "16px" }}
            >
              Demo
            </BlockText>
            <BlockText
              color="grey"
              top="265px"
              left="20px"
              style={{
                fontSize: "12px",
                fontWeight: "500",
                textAlign: "center",
              }}
            >
              This take you through the HCP journey within their practise
              workflow.
            </BlockText>
            <BlockText 
              color="grey"
              top="400px"
              left="20px"
              style={{
                fontSize: "12px",
                fontWeight: "500",
                textAlign: "center",
              }}>
              <Button style={{marginLeft: "25px",marginTop: "-78px"}} onClick={this.handleOpenPopup.bind(this)} >customize</Button>
            </BlockText>
          </Block>

          <Block1>
            {/* <RiHeartPulseLine size="150" color="lightgrey"/> */}
            <img
              src={Heart}
              alt="Heart"
              style={{
                borderRadius: "20px",
                width: "210px",
                marginTop: "-5px",
                marginLeft: "-5px",
              }}
            />
            <BlockText
              color="lightgrey"
              top="213px"
              left="45px"
              style={{ fontSize: "15.5px" }}
            >
              Social Display
            </BlockText>
            <BlockText
              color="lightgrey"
              top="233px"
              left="70px"
              style={{ fontSize: "16px" }}
            >
              Demo
            </BlockText>
            <BlockText
              color="grey"
              top="263px"
              left="20px"
              style={{
                fontSize: "12px",
                fontWeight: "500",
                textAlign: "center",
              }}
            >
              This take you through the HCP journey within their practise
              workflow.
            </BlockText>
          </Block1>
        </Container>

        <Toast
          ref={(el) => {
            this.toast = el;
          }}
        ></Toast>
        {this.state.open && <CustomizePopup open = {this.state.open} onClose = {this.handleClosePopup}/>}
      </div>
    );
  }
}

OgilyHome.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(OgilyHome);
